import { useSubmitTask } from "@/hooks";
import { ProcessType, TaskType } from "@/types";

/**
 * Returns a `submit(body)` callback that posts the customer-information task
 * for the current flow. Thin wrapper over `useSubmitTask` that pins
 * `taskType` to `CustomerInformation`.
 */
export const useCustomerInformationSubmit = <T>({
	taskId,
	processType,
}: {
	taskId: string;
	processType: ProcessType;
}) =>
	useSubmitTask<T>({
		taskId,
		processType,
		taskType: TaskType.CustomerInformation,
	});
